import { HttpClient, HttpParams } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { BehaviorSubject, tap } from 'rxjs'
import { environment } from '../../../../environments/environment'
import {
  WebhookEventDetailModel,
  WebhookEventModel,
} from '../../../core/models/webhook-event.model'

interface WebhookPaginatedResponse {
  status: number
  data: WebhookEventModel[]
  meta: {
    current_page: number
    per_page: number
    total: number
    last_page: number
  }
  message: string
}

interface WebhookDetailResponse {
  status: number
  data: WebhookEventDetailModel
  message: string
}

@Injectable({
  providedIn: 'root',
})
export class WebhookService {
  private http = inject(HttpClient)
  private apiUrl = environment.apiUrl

  private webhooks = new BehaviorSubject<WebhookEventModel[]>([])
  private total = new BehaviorSubject<number>(0)
  private loading = new BehaviorSubject<boolean>(false)
  private selectedWebhook = new BehaviorSubject<WebhookEventDetailModel | null>(
    null
  )
  private detailLoading = new BehaviorSubject<boolean>(false)

  public webhooks$ = this.webhooks.asObservable()
  public total$ = this.total.asObservable()
  public loading$ = this.loading.asObservable()
  public selectedWebhook$ = this.selectedWebhook.asObservable()
  public detailLoading$ = this.detailLoading.asObservable()

  getWebhooks(
    page = 1,
    perPage = 15,
    provider?: string,
    status?: string,
    search?: string
  ) {
    this.loading.next(true)
    let params = new HttpParams().set('page', page).set('perPage', perPage)
    if (provider) params = params.set('provider', provider)
    if (status) params = params.set('status', status)
    if (search) params = params.set('search', search)

    return this.http
      .get<WebhookPaginatedResponse>(`${this.apiUrl}/webhooks`, { params })
      .pipe(
        tap((res) => {
          this.webhooks.next(res.data)
          this.total.next(res.meta.total)
          this.loading.next(false)
        })
      )
  }

  getWebhook(id: number) {
    this.detailLoading.next(true)
    return this.http
      .get<WebhookDetailResponse>(`${this.apiUrl}/webhooks/${id}`)
      .pipe(
        tap((res) => {
          this.selectedWebhook.next(res.data)
          this.detailLoading.next(false)
        })
      )
  }

  clearSelected() {
    this.selectedWebhook.next(null)
  }
}
